/* ==========================================================================
   PMT · Subscription product controller
   - Gallery / reviews / accordions
   - Custom Frequency UI drives Appstle's selling_plan radios (same ATC path)
   - Add-to-cart via fetch; cart drawer opens via PubSub
   ========================================================================== */
(function () {
  'use strict';

  var PubSub = window.PmtPubSub || (function () {
    var subscribers = {};
    return {
      subscribe: function (event, cb) {
        (subscribers[event] = subscribers[event] || []).push(cb);
        return function () {
          subscribers[event] = (subscribers[event] || []).filter(function (fn) {
            return fn !== cb;
          });
        };
      },
      publish: function (event, data) {
        (subscribers[event] || []).forEach(function (cb) {
          try { cb(data); } catch (e) { /* no-op */ }
        });
      }
    };
  })();
  window.PmtPubSub = PubSub;

  var EVENTS = {
    added: 'cart:added',
    error: 'cart:error'
  };

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function initProduct(el) {
    if (el.__pmtInit) return;
    el.__pmtInit = true;

    var data = { variants: {} };
    var dataEl = el.querySelector('[data-pmt-variant-data]');
    if (dataEl) {
      try { data = JSON.parse(dataEl.textContent) || data; } catch (e) { /* keep default */ }
    }

    var form = el.querySelector('[data-pmt-form]') || el.querySelector('form');
    var idInput = el.querySelector('[data-pmt-variant-id]');
    var planMirror = el.querySelector('[data-pmt-selling-plan]');
    var atcBtn = el.querySelector('[data-pmt-atc]');
    var atcText = el.querySelector('[data-pmt-atc-text]');
    var onetimePriceEl = el.querySelector('[data-pmt-onetime-price]');
    var subWasEl = el.querySelector('[data-pmt-sub-was]');
    var subNowEl = el.querySelector('[data-pmt-sub-now]');
    var planSelect = el.querySelector('[data-pmt-plan-select]');
    var subscribeInput = el.querySelector('[data-pmt-subscribe-input]');
    var subscribeCard = el.querySelector('[data-pmt-freq="subscribe"]');
    var onetimeCard = el.querySelector('[data-pmt-freq="onetime"]');
    var productPlans = Array.isArray(data.productPlans) ? data.productPlans : [];
    var syncingAppstle = false;

    var initialFreqInput = el.querySelector('[data-pmt-freq-input]:checked');
    var initialFrequency = (initialFreqInput && initialFreqInput.hasAttribute('data-pmt-subscribe-input'))
      ? 'subscribe'
      : 'onetime';

    var state = {
      variantId: idInput ? String(idInput.value) : '',
      frequency: initialFrequency,
      planId: (planSelect && planSelect.value) || (subscribeInput && subscribeInput.value) || ''
    };

    function logSub() {
      var args = ['[PMT Subscription]'].concat(Array.prototype.slice.call(arguments));
      console.log.apply(console, args);
    }

    function variant() {
      return data.variants[state.variantId] || {};
    }

    function variantPlanIds(v) {
      return Object.keys((v && v.plans) || {});
    }

    function planNameById(planId) {
      var id = String(planId || '');
      if (!id) return '';
      var v = variant();
      if (v.plans && v.plans[id] && v.plans[id].name) return String(v.plans[id].name);
      for (var i = 0; i < productPlans.length; i++) {
        if (String(productPlans[i].id) === id) return String(productPlans[i].name || '');
      }
      if (planSelect) {
        var opt = planSelect.querySelector('option[value="' + id.replace(/"/g, '\\"') + '"]');
        if (opt) return String(opt.textContent || '').trim();
      }
      return '';
    }

    /**
     * Resolve a selling_plan ID allocated to the CURRENT variant.
     * Product-level plan IDs can differ per pack — match exact ID, then name, then first.
     */
    function resolvePlanForVariant(preferredPlanId) {
      var v = variant();
      var plans = (v && v.plans) || {};
      var keys = Object.keys(plans);
      if (!keys.length) {
        return { planId: '', reason: 'variant-has-no-allocations' };
      }

      var preferred = preferredPlanId ? String(preferredPlanId).trim() : '';
      if (preferred && plans[preferred]) {
        return { planId: preferred, reason: 'exact-id' };
      }

      var preferredName = '';
      if (planSelect && planSelect.selectedOptions && planSelect.selectedOptions[0]) {
        preferredName = String(planSelect.selectedOptions[0].textContent || '').trim();
      }
      if (!preferredName && preferred) preferredName = planNameById(preferred);

      if (preferredName) {
        for (var i = 0; i < keys.length; i++) {
          var name = plans[keys[i]] && plans[keys[i]].name;
          if (name && String(name).trim() === preferredName) {
            return { planId: keys[i], reason: 'matched-by-name', matchedName: preferredName };
          }
        }
      }

      return { planId: keys[0], reason: 'first-allocation-fallback' };
    }

    /* ---- Appstle bridge (WIDGET_TYPE_7: radios + #appstle_selling_plan select) ---- */
    function appstleScope() {
      return form || el || document;
    }

    function appstleWidget() {
      return appstleScope().querySelector(
        '#appstle_subscription_widget0, [id^="appstle_subscription_widget"]'
      );
    }

    function $jq() {
      return window.jQuery || window.$ || null;
    }

    function appstlePlanRadios() {
      var widget = appstleWidget();
      if (!widget) return [];
      return widget.querySelectorAll('input[type="radio"][name="selling_plan"]');
    }

    function appstlePlanSelect() {
      var widget = appstleWidget();
      if (!widget) return null;
      return widget.querySelector('select.appstle_select, select[id^="appstle_selling_plan"]');
    }

    function radioRealValue(radio) {
      if (!radio) return '';
      return String(
        radio.getAttribute('data-appstle-real-value') ||
        radio.value ||
        radio.getAttribute('value') ||
        ''
      ).trim();
    }

    function readAppstleSellingPlan() {
      var live = '';
      if (typeof window.appstleSelectedSellingPlan !== 'undefined' &&
          window.appstleSelectedSellingPlan !== null &&
          String(window.appstleSelectedSellingPlan).trim() !== '' &&
          isFinite(parseInt(window.appstleSelectedSellingPlan, 10))) {
        live = String(window.appstleSelectedSellingPlan).trim();
      }

      var select = appstlePlanSelect();
      if (select && select.value && isFinite(parseInt(select.value, 10))) {
        live = String(select.value).trim();
      }

      var radios = appstlePlanRadios();
      var i;
      for (i = 0; i < radios.length; i++) {
        if (!radios[i].checked) continue;
        var val = radioRealValue(radios[i]);
        if (val && isFinite(parseInt(val, 10))) live = val;
      }

      if (live && isFinite(parseInt(live, 10))) return live;

      var inputs = appstleScope().querySelectorAll('[name="selling_plan"]');
      for (i = 0; i < inputs.length; i++) {
        var v = String(inputs[i].value || '').trim();
        if (v && isFinite(parseInt(v, 10))) return v;
      }
      return '';
    }

    /**
     * Trigger Appstle the same way a shopper would:
     * check one-time / Subscribe radio, set plan <select>, fire jQuery change/click.
     */
    function selectAppstlePlan(planId) {
      var want = planId ? String(planId).trim() : '';
      var widget = appstleWidget();
      var $ = $jq();

      if (!widget) {
        if (planMirror) planMirror.value = want;
        logSub('Appstle widget not ready yet', { want: want });
        return false;
      }

      syncingAppstle = true;

      function triggerEl(node) {
        if (!node) return;
        if ($) {
          $(node).prop('checked', true);
          $(node).trigger('click');
          $(node).trigger('change');
        } else {
          node.checked = true;
          try {
            node.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true }));
            node.dispatchEvent(new Event('change', { bubbles: true }));
          } catch (e) {
            if (typeof node.click === 'function') node.click();
          }
        }
      }

      function findOneTimeRadio() {
        var radios = appstlePlanRadios();
        var i;
        var byId = widget.querySelector(
          '#appstle_selling_plan_label_10, input[id^="appstle_selling_plan_label_1"]'
        );
        if (byId) return byId;
        var onetimeBlock = widget.querySelector(
          '.appstle_onetime_block input[name="selling_plan"], ' +
          '.appstle_subscription_wrapper_option:not(.appstle_include_dropdown) input[name="selling_plan"]'
        );
        if (onetimeBlock && !/subscribe/i.test(radioRealValue(onetimeBlock))) return onetimeBlock;
        for (i = 0; i < radios.length; i++) {
          var real = radioRealValue(radios[i]);
          if (!real || real === '') return radios[i];
        }
        return null;
      }

      function findSubscribeRadio() {
        var byId = widget.querySelector(
          '#appstle_selling_plan_label_20, input[id^="appstle_selling_plan_label_2"]'
        );
        if (byId) return byId;
        var radios = appstlePlanRadios();
        var i;
        for (i = 0; i < radios.length; i++) {
          var real = radioRealValue(radios[i]);
          if (/subscribe/i.test(real) || real === 'Subscribe and save') return radios[i];
          if (radios[i].closest('.appstle_include_dropdown')) return radios[i];
        }
        /* Direct plan-id radios (other widget types) */
        for (i = 0; i < radios.length; i++) {
          var val = radioRealValue(radios[i]);
          if (want && val === want) return radios[i];
          if (val && isFinite(parseInt(val, 10))) return radios[i];
        }
        return null;
      }

      function setSelectPlan(id) {
        var select = appstlePlanSelect();
        if (!select || !id) return false;
        var options = select.options;
        var matched = '';
        var i;
        for (i = 0; i < options.length; i++) {
          var ov = String(options[i].value || '').trim();
          if (ov === id || ov.indexOf(id) !== -1 || ov.endsWith('/' + id)) {
            matched = ov;
            break;
          }
        }
        if (!matched && options.length) {
          /* Fallback: first numeric option */
          for (i = 0; i < options.length; i++) {
            var ov2 = String(options[i].value || '').trim();
            if (ov2 && isFinite(parseInt(ov2, 10))) {
              matched = ov2;
              break;
            }
          }
        }
        if (!matched) return false;
        if ($) {
          $(select).val(matched).trigger('change').trigger('input');
        } else {
          select.value = matched;
          try {
            select.dispatchEvent(new Event('change', { bubbles: true }));
          } catch (e2) { /* no-op */ }
        }
        return true;
      }

      var ok = false;

      if (!want) {
        window.appstleSelectedSellingPlan = '';
        var oneTime = findOneTimeRadio();
        if (oneTime) {
          /* Restore blanked one-time value */
          if (oneTime.getAttribute('data-appstle-real-value') === '') {
            oneTime.setAttribute('value', '');
          }
          triggerEl(oneTime);
          ok = true;
        }
      } else {
        var subRadio = findSubscribeRadio();
        if (subRadio) {
          var realSub = radioRealValue(subRadio);
          /* Appstle blanks inactive radios — restore Subscribe value before click */
          if (!subRadio.value || !/subscribe/i.test(subRadio.value)) {
            if (/subscribe/i.test(realSub) || realSub === 'Subscribe and save') {
              subRadio.setAttribute('value', realSub || 'Subscribe and save');
            } else if (!isFinite(parseInt(subRadio.value, 10))) {
              subRadio.setAttribute(
                'value',
                realSub && !isFinite(parseInt(realSub, 10)) ? realSub : 'Subscribe and save'
              );
            }
          }
          triggerEl(subRadio);
          ok = true;
        }

        /* Set frequency dropdown to the resolved plan id (WIDGET_TYPE_7) */
        if (setSelectPlan(want)) ok = true;

        /* Ensure checked selling_plan radio carries the numeric plan id (Appstle does this) */
        var checked = widget.querySelector('input[name="selling_plan"]:checked');
        if (checked && want) {
          checked.setAttribute('value', want);
          checked.value = want;
        }

        /* Direct plan-id radio fallback */
        var radios = appstlePlanRadios();
        for (var r = 0; r < radios.length; r++) {
          if (radioRealValue(radios[r]) === want) {
            if (!radios[r].value) radios[r].setAttribute('value', want);
            triggerEl(radios[r]);
            ok = true;
            break;
          }
        }

        window.appstleSelectedSellingPlan = want;
      }

      if (planMirror) planMirror.value = want;

      /* Let Appstle finish updateStateOfWidget / updateFormFields */
      window.setTimeout(function () {
        syncingAppstle = false;
        logSub('triggered Appstle selection', {
          requested: planId || '',
          applied: want,
          live: readAppstleSellingPlan(),
          appstleSelectedSellingPlan: window.appstleSelectedSellingPlan || null,
          hasSelect: !!appstlePlanSelect(),
          radioCount: appstlePlanRadios().length
        });
      }, 40);

      return ok;
    }

    function notifyAppstleVariantChange() {
      if (!idInput) return;
      var $ = $jq();
      if ($) {
        $(idInput).trigger('change').trigger('input');
      } else {
        try {
          idInput.dispatchEvent(new Event('change', { bubbles: true }));
          idInput.dispatchEvent(new Event('input', { bubbles: true }));
        } catch (e) { /* no-op */ }
      }
    }

    function subscriptionSnapshot() {
      var v = variant();
      return {
        productId: data.productId || el.getAttribute('data-product-id'),
        frequency: state.frequency,
        variantId: state.variantId,
        variantTitle: v.title || null,
        planId: state.planId,
        appstleLive: readAppstleSellingPlan(),
        planSelectValue: planSelect ? planSelect.value : null,
        subscribeRadioValue: subscribeInput ? subscribeInput.value : null,
        variantHasPlans: variantPlanIds(v),
        appstleRadioCount: appstlePlanRadios().length
      };
    }

    (function logSellingPlans() {
      var variants = data.variants || {};
      var variantIds = Object.keys(variants);
      var variantsWithPlans = [];
      var variantsWithoutPlans = [];

      variantIds.forEach(function (vid) {
        var v = variants[vid] || {};
        var plans = v.plans || {};
        var planIds = Object.keys(plans);
        var entry = {
          variantId: vid,
          title: v.title || null,
          planCount: planIds.length,
          plans: planIds.map(function (pid) {
            return { id: pid, name: plans[pid] && plans[pid].name, price: plans[pid] && plans[pid].price };
          })
        };
        if (planIds.length) variantsWithPlans.push(entry);
        else variantsWithoutPlans.push(entry);
      });

      logSub('Selling plan check', {
        productId: data.productId || el.getAttribute('data-product-id'),
        productPlans: productPlans,
        variantsWithPlans: variantsWithPlans,
        variantsWithoutPlans: variantsWithoutPlans
      });

      if (variantsWithoutPlans.length) {
        console.warn(
          '[PMT Subscription] Packs with no selling_plan_allocations (enable in Appstle):',
          variantsWithoutPlans
        );
      }
    })();

    function activeCurrency() {
      return (data && data.currency)
        || (window.Shopify && window.Shopify.currency && window.Shopify.currency.active)
        || window.shopCurrency
        || null;
    }

    function currencySymbol() {
      var sym = data && data.currencySymbol;
      return sym ? String(sym).trim() : '';
    }

    function moneyFormatString() {
      return (data && data.moneyFormat)
        || (window.theme && window.theme.moneyFormat)
        || (window.Shopify && window.Shopify.money_format)
        || null;
    }

    /** Always show two decimals (e.g. Rs 1,200.00). */
    function formatAmountNumber(amount) {
      var n = Number(amount);
      try {
        return new Intl.NumberFormat(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }).format(n);
      } catch (e) {
        return n.toFixed(2);
      }
    }

    /**
     * Format cents with a currency SIGN (Rs, €, $), never the ISO code (PKR, EUR).
     */
    function formatMoney(cents) {
      var n = Number(cents);
      if (!isFinite(n)) return '';
      var amount = n / 100;
      var symbol = currencySymbol();

      /* 1) Presentment currency symbol from cart (Shopify Markets) */
      if (symbol) {
        var needsSpace = /[A-Za-z]/.test(symbol);
        return symbol + (needsSpace ? ' ' : '') + formatAmountNumber(amount);
      }

      /* 2) Theme / shop money_format (uses configured sign, not ISO) */
      var fmt = moneyFormatString();
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function' && fmt) {
        try {
          var viaShopify = String(window.Shopify.formatMoney(n, fmt)).replace(/<[^>]+>/g, '').trim();
          if (viaShopify && !/^[A-Z]{3}\s/.test(viaShopify)) return viaShopify;
        } catch (e) { /* fall through */ }
      }

      /* 3) Intl with narrow symbol (avoids "PKR" where possible) */
      var currency = activeCurrency();
      if (currency && window.Intl && typeof Intl.NumberFormat === 'function') {
        try {
          return new Intl.NumberFormat(undefined, {
            style: 'currency',
            currency: currency,
            currencyDisplay: 'narrowSymbol'
          }).format(amount);
        } catch (e2) { /* fall through */ }
      }

      return formatAmountNumber(amount);
    }

    function unitPriceCents() {
      if (isFinite(Number(data.unitPriceCents))) return Number(data.unitPriceCents);
      var ids = Object.keys(data.variants || {});
      for (var i = 0; i < ids.length; i++) {
        var v = data.variants[ids[i]];
        if (v && Number(v.qty) === 1 && isFinite(Number(v.priceCents))) return Number(v.priceCents);
      }
      return 0;
    }

    function planPriceForVariant(v, planId) {
      if (!v || !v.plans) return null;
      if (planId && v.plans[planId]) return v.plans[planId];
      var keys = Object.keys(v.plans);
      return keys.length ? v.plans[keys[0]] : null;
    }

    /** Refresh pack prices / save / % badges when one-time vs subscribe changes. */
    function updateVariantOptionPrices() {
      var isSub = state.frequency === 'subscribe';
      var unit = unitPriceCents();
      var preferredPlan = state.planId;

      el.querySelectorAll('[data-pmt-variant]').forEach(function (opt) {
        var vid = opt.getAttribute('data-pmt-variant');
        var v = data.variants[vid];
        if (!v) return;

        var qty = Number(opt.getAttribute('data-pmt-variant-qty') || v.qty || 1) || 1;
        var oneTimeCents = Number(v.priceCents) || 0;
        var plan = isSub ? planPriceForVariant(v, preferredPlan) : null;
        var packCents = (isSub && plan && isFinite(Number(plan.priceCents)))
          ? Number(plan.priceCents)
          : oneTimeCents;

        /* Reference (regular) price to measure savings against */
        var refCents = oneTimeCents;
        if (isFinite(Number(v.compareCents)) && Number(v.compareCents) > refCents) {
          refCents = Number(v.compareCents);
        } else if (qty > 1 && unit > 0 && unit * qty > refCents) {
          refCents = unit * qty;
        }

        /* Savings based on the active (one-time or subscription discounted) price */
        var saveCents = refCents > packCents ? (refCents - packCents) : 0;

        var priceEl = opt.querySelector('[data-pmt-variant-price]');
        var saveEl = opt.querySelector('[data-pmt-variant-save]');

        if (priceEl) {
          if (!isSub) {
            /* One-time: per-bottle “Each” for any multi-pack, full variant price for singles */
            if (qty > 1) {
              priceEl.textContent = formatMoney(Math.round(oneTimeCents / qty)) + ' Each';
            } else {
              priceEl.textContent = v.price ? String(v.price) : formatMoney(oneTimeCents);
            }
          } else if (qty > 1) {
            /* Subscribe: per-bottle “Each” for any multi-pack */
            priceEl.textContent = formatMoney(Math.round(packCents / qty)) + ' Each';
          } else if (plan && plan.price) {
            priceEl.textContent = String(plan.price);
          } else {
            priceEl.textContent = formatMoney(packCents);
          }
        }

        if (saveEl) {
          if (saveCents > 0) {
            saveEl.textContent = 'Save ' + formatMoney(saveCents);
            saveEl.hidden = false;
            saveEl.classList.remove('is-empty');
          } else {
            saveEl.textContent = '';
            saveEl.hidden = true;
            saveEl.classList.add('is-empty');
          }
        }
      });
    }

    /**
     * Write a price, keeping the machine-readable value="" attribute in step with the
     * visible text. `text` is the display price ($70.40); `amount` is the bare number
     * (70.40) that value="" carries, supplied by the section as variants[].priceAmount.
     * The section server-renders both on [data-pmt-onetime-price]
     * (sections/pmt-pvt-product.liquid); without this, value="" would go stale on the
     * first variant change. The regex is only a fallback for a stale cached payload.
     */
    function setPriceAndValue(node, text, amount) {
      if (!node) return;
      node.textContent = text;
      var value = amount;
      if (!value) {
        /* Fallback for a stale cached payload. Strip the currency symbol, then treat
           whichever of '.' or ',' comes last as the decimal separator, so both
           1,234.56 and 1.234,56 normalise to 1234.56. */
        value = String(text).replace(/[^0-9.,]/g, '');
        value = value.lastIndexOf(',') > value.lastIndexOf('.')
          ? value.replace(/\./g, '').replace(',', '.')
          : value.replace(/,/g, '');
      }
      node.setAttribute('value', value);
    }

    function updatePrices() {
      var v = variant();
      if (onetimePriceEl && v.price) setPriceAndValue(onetimePriceEl, v.price, v.priceAmount);
      if (subWasEl && v.price) subWasEl.textContent = v.price;
      if (subNowEl) {
        var resolved = resolvePlanForVariant(state.planId);
        var alloc = resolved.planId && v.plans && v.plans[resolved.planId];
        subNowEl.textContent = (alloc && alloc.price) || v.price || '';
      }
      updateVariantOptionPrices();
    }

    function selectionReady() {
      var vid = String(state.variantId || '').trim();
      if (!vid || !data.variants[vid]) return false;
      if (!isFinite(parseInt(vid, 10))) return false;
      if (idInput && String(idInput.value) !== vid) return false;

      if (state.frequency === 'subscribe') {
        var live = readAppstleSellingPlan() || String(state.planId || '').trim();
        if (!live || !isFinite(parseInt(live, 10))) return false;
      }
      return true;
    }

    function setAtcEnabled(enabled) {
      if (!atcBtn) return;
      var available = variant().available !== false;
      var ready = !!enabled && available && selectionReady();
      atcBtn.disabled = !ready;
      atcBtn.classList.toggle('is-updating', !ready && available);
      if (atcText) {
        atcText.textContent = available
          ? atcBtn.getAttribute('data-atc-label')
          : atcBtn.getAttribute('data-soldout-label');
      }
    }

    function applyPurchaseSelection(preferredPlanId) {
      var vid = String(state.variantId || '').trim();
      if (idInput) idInput.value = vid;

      if (state.frequency === 'subscribe') {
        var resolved = resolvePlanForVariant(preferredPlanId || state.planId);
        state.planId = resolved.planId ? String(resolved.planId) : '';
        if (subscribeInput && state.planId) subscribeInput.value = state.planId;
        selectAppstlePlan(state.planId);
      } else {
        selectAppstlePlan('');
      }

      logSub('apply purchase selection', subscriptionSnapshot());
      return selectionReady();
    }

    /** Re-fire Appstle when the widget finishes loading after a custom selection. */
    function syncCustomToAppstle() {
      if (state.frequency === 'subscribe') {
        selectAppstlePlan(state.planId);
      } else {
        selectAppstlePlan('');
      }
      setAtcEnabled(true);
    }

    function setFrequency(isSubscribe, planId) {
      setAtcEnabled(false);
      state.frequency = isSubscribe ? 'subscribe' : 'onetime';

      if (isSubscribe) {
        var resolved = resolvePlanForVariant(planId || state.planId);
        if (!resolved.planId) {
          logSub('subscribe blocked — no allocations for variant', subscriptionSnapshot());
          state.frequency = 'onetime';
          isSubscribe = false;
        } else {
          state.planId = String(resolved.planId);
        }
      }

      if (subscribeInput) {
        subscribeInput.checked = !!isSubscribe;
        if (isSubscribe && state.planId) subscribeInput.value = String(state.planId);
      }
      if (onetimeCard) {
        var onetimeInput = onetimeCard.querySelector('[data-pmt-freq-input]');
        if (onetimeInput) onetimeInput.checked = !isSubscribe;
        onetimeCard.classList.toggle('pmt-option--active', !isSubscribe);
      }
      if (subscribeCard) {
        subscribeCard.classList.toggle('pmt-subscribe--active', isSubscribe);
        subscribeCard.classList.toggle('pmt-subscribe--disabled', !variantPlanIds(variant()).length);
      }
      if (planSelect && isSubscribe && state.planId) {
        var hasOption = !!planSelect.querySelector('option[value="' + String(state.planId).replace(/"/g, '\\"') + '"]');
        if (hasOption) planSelect.value = state.planId;
      }

      updatePrices();
      applyPurchaseSelection(planId);
      setAtcEnabled(true);
      logSub('frequency changed', subscriptionSnapshot());
    }

    /* ---- Gallery (snap scroll + thumb sync) ---------------------------- */
    var mainTrack = el.querySelector('[data-pmt-main-track]');
    var mainSlides = mainTrack
      ? Array.prototype.slice.call(mainTrack.querySelectorAll('[data-pmt-main-slide]'))
      : [];
    var thumbs = Array.prototype.slice.call(el.querySelectorAll('[data-pmt-thumb]'));
    var thumbsWrap = el.querySelector('[data-pmt-thumbs]');
    var mainPrevBtn = el.querySelector('[data-pmt-main-prev]');
    var mainNextBtn = el.querySelector('[data-pmt-main-next]');
    if (mainTrack && mainSlides.length) {
      var galleryIdx = 0;
      var galleryLock = false;
      var galleryLockTimer = 0;

      var updateArrowState = function (i) {
        if (mainPrevBtn) {
          if (i <= 0) mainPrevBtn.setAttribute('disabled', '');
          else mainPrevBtn.removeAttribute('disabled');
        }
        if (mainNextBtn) {
          if (i >= mainSlides.length - 1) mainNextBtn.setAttribute('disabled', '');
          else mainNextBtn.removeAttribute('disabled');
        }
      };

      var setActiveThumb = function (i) {
        if (i < 0 || i >= mainSlides.length) return;
        galleryIdx = i;
        thumbs.forEach(function (t, ti) {
          var on = ti === i;
          t.classList.toggle('pmt-gallery__thumb--active', on);
          if (on) t.setAttribute('aria-current', 'true');
          else t.removeAttribute('aria-current');
        });
        if (thumbsWrap && thumbs[i]) {
          var thumb = thumbs[i];
          var left = thumb.offsetLeft - (thumbsWrap.clientWidth - thumb.offsetWidth) / 2;
          thumbsWrap.scrollTo({ left: Math.max(0, left), behavior: 'smooth' });
        }
        updateArrowState(i);
      };

      var slideWidth = function () {
        return mainTrack.clientWidth || mainSlides[0].getBoundingClientRect().width || 1;
      };

      var indexFromScroll = function () {
        var w = slideWidth();
        var i = Math.round(mainTrack.scrollLeft / w);
        return Math.max(0, Math.min(mainSlides.length - 1, i));
      };

      var goToSlide = function (i) {
        if (i < 0 || i >= mainSlides.length) return;
        galleryLock = true;
        window.clearTimeout(galleryLockTimer);
        setActiveThumb(i);
        mainTrack.scrollTo({ left: Math.round(i * slideWidth()), behavior: 'smooth' });
        galleryLockTimer = window.setTimeout(function () {
          galleryLock = false;
          setActiveThumb(indexFromScroll());
        }, 500);
      };

      var syncFromScroll = function () {
        if (galleryLock) return;
        var nearest = indexFromScroll();
        if (nearest !== galleryIdx) setActiveThumb(nearest);
      };

      var galleryRaf = 0;
      mainTrack.addEventListener('scroll', function () {
        if (galleryRaf) return;
        galleryRaf = window.requestAnimationFrame(function () {
          galleryRaf = 0;
          syncFromScroll();
        });
      }, { passive: true });

      mainTrack.addEventListener('scrollend', function () {
        galleryLock = false;
        setActiveThumb(indexFromScroll());
      });

      if (typeof IntersectionObserver === 'function') {
        var galleryIo = new IntersectionObserver(function (entries) {
          if (galleryLock) return;
          var best = null;
          var bestRatio = 0;
          for (var e = 0; e < entries.length; e++) {
            var entry = entries[e];
            if (entry.isIntersecting && entry.intersectionRatio > bestRatio) {
              bestRatio = entry.intersectionRatio;
              best = entry.target;
            }
          }
          if (!best || bestRatio < 0.55) return;
          var idxAttr = best.getAttribute('data-index');
          var i = idxAttr != null ? parseInt(idxAttr, 10) : mainSlides.indexOf(best);
          if (!isFinite(i) || i < 0) return;
          if (i !== galleryIdx) setActiveThumb(i);
        }, {
          root: mainTrack,
          threshold: [0.55, 0.75, 1]
        });
        mainSlides.forEach(function (slide) { galleryIo.observe(slide); });
      }

      thumbs.forEach(function (thumb, ti) {
        thumb.addEventListener('click', function () {
          var idxAttr = thumb.getAttribute('data-index');
          var i = idxAttr != null ? parseInt(idxAttr, 10) : ti;
          if (!isFinite(i)) i = ti;
          goToSlide(i);
        });
      });

      if (mainPrevBtn) {
        mainPrevBtn.addEventListener('click', function () {
          if (galleryIdx <= 0) return;
          goToSlide(galleryIdx - 1);
        });
      }

      if (mainNextBtn) {
        mainNextBtn.addEventListener('click', function () {
          if (galleryIdx >= mainSlides.length - 1) return;
          goToSlide(galleryIdx + 1);
        });
      }

      setActiveThumb(0);
    }

    /* ---- Reviews ------------------------------------------------------- */
    // var reviewRoot = el.querySelector('[data-pmt-reviews]');
    // var track = reviewRoot && reviewRoot.querySelector('[data-pmt-review-track]');
    // var slides = reviewRoot ? reviewRoot.querySelectorAll('[data-pmt-review-slide]') : [];
    // if (track && slides.length > 1) {
    //   var dots = reviewRoot.querySelectorAll('[data-pmt-review-dot]');
    //   var idx = 0;
    //   var scrolling = false;
    //   var syncDots = function () {
    //     dots.forEach(function (d, di) {
    //       d.classList.toggle('pmt-reviews__dot--active', di === idx);
    //     });
    //   };
    //   var slideLeft = function (i) {
    //     return slides[i].offsetLeft - slides[0].offsetLeft;
    //   };
    //   var goTo = function (i) {
    //     idx = (i + slides.length) % slides.length;
    //     scrolling = true;
    //     track.scrollTo({ left: slideLeft(idx), behavior: 'smooth' });
    //     syncDots();
    //     window.setTimeout(function () { scrolling = false; }, 450);
    //   };
    //   var syncFromScroll = function () {
    //     if (scrolling) return;
    //     var nearest = 0;
    //     var minDist = Infinity;
    //     var left = track.scrollLeft;
    //     for (var i = 0; i < slides.length; i++) {
    //       var dist = Math.abs(slideLeft(i) - left);
    //       if (dist < minDist) {
    //         minDist = dist;
    //         nearest = i;
    //       }
    //     }
    //     if (nearest !== idx) {
    //       idx = nearest;
    //       syncDots();
    //     }
    //   };
    //   var scrollRaf = 0;
    //   track.addEventListener('scroll', function () {
    //     if (scrollRaf) return;
    //     scrollRaf = window.requestAnimationFrame(function () {
    //       scrollRaf = 0;
    //       syncFromScroll();
    //     });
    //   }, { passive: true });
    //   var prev = reviewRoot.querySelector('[data-pmt-review-prev]');
    //   var next = reviewRoot.querySelector('[data-pmt-review-next]');
    //   if (prev) prev.addEventListener('click', function () { goTo(idx - 1); });
    //   if (next) next.addEventListener('click', function () { goTo(idx + 1); });
    //   dots.forEach(function (d, di) {
    //     d.addEventListener('click', function () { goTo(di); });
    //   });
    // }

        el.querySelectorAll('[data-pmt-reviews]').forEach(function (reviewRoot) {
      var track = reviewRoot.querySelector('[data-pmt-review-track]');
      var slides = reviewRoot.querySelectorAll('[data-pmt-review-slide]');
      if (!track || slides.length < 2) return;
      var dots = reviewRoot.querySelectorAll('[data-pmt-review-dot]');
      var idx = 0;
      var scrolling = false;
      var syncDots = function () {
        dots.forEach(function (d, di) {
          d.classList.toggle('pmt-reviews__dot--active', di === idx);
        });
      };
      var slideLeft = function (i) {
        return slides[i].offsetLeft - slides[0].offsetLeft;
      };
      var goTo = function (i) {
        idx = (i + slides.length) % slides.length;
        scrolling = true;
        track.scrollTo({ left: slideLeft(idx), behavior: 'smooth' });
        syncDots();
        window.setTimeout(function () { scrolling = false; }, 450);
      };
      var syncFromScroll = function () {
        if (scrolling) return;
        var nearest = 0;
        var minDist = Infinity;
        var left = track.scrollLeft;
        for (var i = 0; i < slides.length; i++) {
          var dist = Math.abs(slideLeft(i) - left);
          if (dist < minDist) {
            minDist = dist;
            nearest = i;
          }
        }
        if (nearest !== idx) {
          idx = nearest;
          syncDots();
        }
      };
      var scrollRaf = 0;
      track.addEventListener('scroll', function () {
        if (scrollRaf) return;
        scrollRaf = window.requestAnimationFrame(function () {
          scrollRaf = 0;
          syncFromScroll();
        });
      }, { passive: true });
      var prev = reviewRoot.querySelector('[data-pmt-review-prev]');
      var next = reviewRoot.querySelector('[data-pmt-review-next]');
      if (prev) prev.addEventListener('click', function () { goTo(idx - 1); });
      if (next) next.addEventListener('click', function () { goTo(idx + 1); });
      dots.forEach(function (d, di) {
        d.addEventListener('click', function () { goTo(di); });
      });
    });

    /* ---- Accordions ---------------------------------------------------- */
    el.querySelectorAll('[data-pmt-accordion]').forEach(function (item) {
      var head = item.querySelector('[data-pmt-accordion-head]');
      var body = item.querySelector('[data-pmt-accordion-body]');
      if (!head || !body) return;
      head.addEventListener('click', function () {
        var open = item.classList.toggle('pmt-accordion--open');
        head.setAttribute('aria-expanded', open ? 'true' : 'false');
        body.style.maxHeight = open ? body.scrollHeight + 'px' : '0px';
      });
    });

    /* ---- Variant / frequency ------------------------------------------- */
    el.querySelectorAll('[data-pmt-variant-input]').forEach(function (input) {
      input.addEventListener('change', function () {
        if (!input.checked) return;
        setAtcEnabled(false);
        state.variantId = String(input.value);
        el.querySelectorAll('[data-pmt-variant]').forEach(function (opt) {
          opt.classList.toggle('pmt-option--active', opt.getAttribute('data-pmt-variant') === input.value);
        });
        if (idInput) idInput.value = state.variantId;
        notifyAppstleVariantChange();

        var preferredPlan = (planSelect && planSelect.value) || state.planId;
        window.setTimeout(function () {
          if (state.frequency === 'subscribe') {
            setFrequency(true, preferredPlan);
          } else {
            updatePrices();
            applyPurchaseSelection();
            if (subscribeCard) {
              subscribeCard.classList.toggle('pmt-subscribe--disabled', !variantPlanIds(variant()).length);
            }
            setAtcEnabled(true);
          }
          logSub('variant changed', subscriptionSnapshot());
        }, 50);
      });
    });

    el.querySelectorAll('[data-pmt-freq-input]').forEach(function (input) {
      input.addEventListener('change', function () {
        if (!input.checked) return;
        var isSub = input.hasAttribute('data-pmt-subscribe-input');
        var planId = isSub
          ? ((planSelect && planSelect.value) || input.value || state.planId)
          : state.planId;
        setFrequency(isSub, planId);
      });
    });

    if (subscribeCard) {
      subscribeCard.addEventListener('click', function (e) {
        if (e.target.closest('select')) return;
        if (!variantPlanIds(variant()).length) {
          logSub('subscribe click ignored — no allocations', subscriptionSnapshot());
          window.alert('Subscription is not available for this pack.');
          return;
        }
        if (subscribeInput && !subscribeInput.checked) {
          subscribeInput.checked = true;
          subscribeInput.dispatchEvent(new Event('change', { bubbles: true }));
        } else if (subscribeInput && subscribeInput.checked) {
          setFrequency(true, (planSelect && planSelect.value) || state.planId);
        }
      });
    }

    if (planSelect) {
      planSelect.addEventListener('click', function (e) { e.stopPropagation(); });
      planSelect.addEventListener('change', function () {
        state.planId = String(planSelect.value);
        if (subscribeInput) {
          subscribeInput.value = state.planId;
          subscribeInput.checked = true;
        }
        setFrequency(true, state.planId);
      });
    }

    /* Keep custom UI in sync if Appstle radios change (defensive) */
    function onAppstleRadioChange() {
      if (syncingAppstle) return;
      var live = readAppstleSellingPlan();
      if (live) {
        state.frequency = 'subscribe';
        state.planId = live;
        if (subscribeInput) {
          subscribeInput.checked = true;
          subscribeInput.value = live;
        }
        if (onetimeCard) onetimeCard.classList.remove('pmt-option--active');
        if (subscribeCard) subscribeCard.classList.add('pmt-subscribe--active');
      } else {
        state.frequency = 'onetime';
        if (subscribeInput) subscribeInput.checked = false;
        if (onetimeCard) onetimeCard.classList.add('pmt-option--active');
        if (subscribeCard) subscribeCard.classList.remove('pmt-subscribe--active');
      }
      updatePrices();
      setAtcEnabled(true);
    }

    function bindAppstleRadios() {
      appstlePlanRadios().forEach(function (radio) {
        if (radio.__pmtBound) return;
        radio.__pmtBound = true;
        radio.addEventListener('change', onAppstleRadioChange);
      });
    }

    document.addEventListener('AppstleSubscription:SubscriptionWidget:widgetInitialised', function () {
      logSub('Appstle widget ready', {
        radios: appstlePlanRadios().length,
        hasSelect: !!appstlePlanSelect()
      });
      bindAppstleRadios();
      syncCustomToAppstle();
    });
    document.addEventListener('AppstleSubscription:SubscriptionWidget:SubscriptionWidgetUpdated', function () {
      if (syncingAppstle) return;
      bindAppstleRadios();
      /* Re-assert custom selection after Appstle re-renders for variant changes */
      window.setTimeout(syncCustomToAppstle, 30);
    });
    document.addEventListener('AppstleSubscription:SubscriptionWidget:SellingPlanSelected', function () {
      if (syncingAppstle) return;
      logSub('Appstle SellingPlanSelected', { live: readAppstleSellingPlan() });
    });

    /* Poll until Appstle injects (WIDGET_TYPE_7 uses radios + select) */
    var pollTries = 0;
    var pollId = window.setInterval(function () {
      pollTries += 1;
      var ready = !!appstleWidget() && (appstlePlanRadios().length > 0 || !!appstlePlanSelect());
      if (ready || pollTries > 40) {
        window.clearInterval(pollId);
        bindAppstleRadios();
        syncCustomToAppstle();
        logSub('Appstle poll done', subscriptionSnapshot());
      }
    }, 250);

    /* ---- Add to cart --------------------------------------------------- */
    function setLoading(on) {
      if (atcBtn) atcBtn.classList.toggle('is-loading', !!on);
    }

    function resolvePurchase() {
      var subscribeChecked = !!(subscribeInput && subscribeInput.checked);
      var subscribeActive = !!(subscribeCard && subscribeCard.classList.contains('pmt-subscribe--active'));
      var isSubscribe = subscribeChecked || subscribeActive || state.frequency === 'subscribe';
      var variantId = String(state.variantId || '').trim();

      var preferred = '';
      if (isSubscribe) {
        preferred = String(
          readAppstleSellingPlan() ||
          (planSelect && planSelect.value) ||
          state.planId ||
          (subscribeInput && subscribeInput.value) ||
          ''
        ).trim();
      }

      var resolved = isSubscribe
        ? resolvePlanForVariant(preferred)
        : { planId: '', reason: 'onetime' };

      /* Prefer Appstle's live value when it is a valid numeric plan id */
      var live = readAppstleSellingPlan();
      var planId = '';
      if (isSubscribe) {
        if (live && isFinite(parseInt(live, 10))) planId = live;
        else planId = resolved.planId || '';
      }

      return {
        isSubscribe: isSubscribe && !!planId,
        variantId: variantId,
        preferredPlanId: preferred,
        planId: planId,
        planIdNum: planId ? parseInt(planId, 10) : NaN,
        resolveReason: live ? 'appstle-live' : (resolved.reason || null)
      };
    }

    function addToCart(item) {
      var body = JSON.stringify({ items: [item] });
      logSub('ATC fetch body', body);
      return fetch(root() + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: body,
        credentials: 'same-origin'
      }).then(function (res) {
        return res.json().then(function (json) {
          if (!res.ok) {
            var err = new Error((json && (json.description || json.message)) || 'Could not add to cart.');
            err.data = json;
            throw err;
          }
          return json;
        });
      });
    }

    function handleAddToCart(e) {
      if (e) {
        e.preventDefault();
        e.stopPropagation();
        if (e.stopImmediatePropagation) e.stopImmediatePropagation();
      }

      applyPurchaseSelection(
        state.frequency === 'subscribe'
          ? ((planSelect && planSelect.value) || state.planId)
          : ''
      );

      if (!selectionReady() || (atcBtn && atcBtn.disabled)) {
        logSub('ATC blocked — not ready', subscriptionSnapshot());
        return;
      }

      var purchase = resolvePurchase();
      var variantIdNum = parseInt(purchase.variantId, 10);
      if (!isFinite(variantIdNum)) {
        logSub('ATC missing variant id', { purchase: purchase });
        return;
      }

      var item = {
        id: variantIdNum,
        quantity: 1
      };

      if (purchase.isSubscribe) {
        if (!purchase.planId || !isFinite(purchase.planIdNum)) {
          logSub('ATC missing selling_plan', { purchase: purchase, snapshot: subscriptionSnapshot() });
          window.alert('Could not apply subscription plan. Please try again.');
          return;
        }
        item.selling_plan = purchase.planIdNum;
      }

      logSub('ATC request', {
        item: item,
        purchase: purchase,
        snapshot: subscriptionSnapshot()
      });

      setLoading(true);
      setAtcEnabled(false);
      addToCart(item)
        .then(function (body) {
          logSub('ATC success', body);
          var added = (body && body.items && body.items[0]) || body;
          logSub('ATC selling_plan_allocation', added && added.selling_plan_allocation
            ? added.selling_plan_allocation
            : null);
          PubSub.publish(EVENTS.added, body);
          return body;
        })
        .catch(function (err) {
          logSub('ATC error', { message: err && err.message, data: err && err.data });
          PubSub.publish(EVENTS.error, err);
          window.alert((err && err.message) || 'Could not add to cart.');
        })
        .finally(function () {
          setLoading(false);
          setAtcEnabled(true);
        });
    }

    if (atcBtn) atcBtn.addEventListener('click', handleAddToCart);
    if (form) form.addEventListener('submit', handleAddToCart);

    setFrequency(initialFrequency === 'subscribe', state.planId);
    logSub('init', subscriptionSnapshot());
  }

  function init() {
    document.querySelectorAll('[data-pmt-product-root]').forEach(initProduct);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
